import DesignTokens from '@tableau/design-tokens';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';
import { SearchBaseIconRaw } from '@tableau/icons/SearchBaseIcon/raw';
import React from 'react';
import _ from 'underscore';

import { IReactTranslateService } from '~commonInfra/services/IReactTranslateService';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

export class SearchBox extends React.Component<SearchBox.Props, any> {

  public static displayName = 'SearchBox';

  public static element = React.createFactory(SearchBox);

  public render() {

    const inputProps = _.extend({},
      {
        placeholder: this.props.translate ? this.props.translate('search') : '',
        className: 'tb-placeholder',
        'data-tb-test-id': 'search-box-input'
      },
      this.props.inputProps);

    inputProps.style = _.extend({},
      {
        fontWeight: 'normal',
        fontSize: CommonStyles.Sizes.NormalFontSize,

        height: CommonStyles.Sizes.RowHeight,

        paddingTop: CommonStyles.Sizes.TextBoxPadding,
        paddingBottom: CommonStyles.Sizes.TextBoxPadding,
        paddingLeft: CommonStyles.Sizes.TextBoxPadding + CommonStyles.Sizes.SmallIconSize,

        borderWidth: CommonStyles.Sizes.TextBoxBorderSize,
        borderColor: applyColor(DesignTokens.color.elevation.border.default.default, CommonStyles.Colors.BorderColor),
        borderStyle: 'solid',

        boxSizing: 'border-box',
        background: `var(${ReactiveRawIconRegistry.register(SearchBaseIconRaw, 16, applyColor(DesignTokens.color.icon.default.default, '#666666'))}) 0 center no-repeat`,
        backgroundSize: CommonStyles.Sizes.NormalIconBackgroundSize,

        outline: 'none'
      },
      this.props.inputProps.style);

    return React.createElement('input',  inputProps);
  }

}

export module SearchBox {

  export interface Props {
    inputProps: React.HTMLProps<HTMLElement>;
    translate?: IReactTranslateService;
  }

}
